import { createGlobalStyle } from 'styled-components/macro';
import { StylesParagraph } from 'components/Paragraph/Paragraph';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    font-family: 'Fira Sans', sans-serif;

    &:focus {
      outline: 1px dotted;
    }
  }

  body,
  html,
  #root {
    height: 100%;
  }

  img {
    display: block;
    max-width: 100%;
  }

  p,
  ul li,
  ol li {
    ${StylesParagraph};
  }

  ul,
  ol {
    margin-left: 24px;
    margin-bottom: 24px;
  } 

  ul li,
  ol li { 
    margin: 0;
  }
`;

export { GlobalStyle };
